import React from "react"
import { Outlet } from "react-router-dom"
import { Layout, theme } from "antd"

import { W1, W3, WIDTH_MAX } from "@components"
import { useOrganizations } from "@components/Organization"


const ConsoleManagerLayout = () => {
  const organizations = useOrganizations();

  const { token } = theme.useToken()

  const { colorBgContainer } = token

  const layoutStyle = {
    backgroundColor: colorBgContainer
  }

  const layoutContentStyle = {
    width: "100%",
    margin: "0 auto",
    padding: `${W3}px ${W1}px`,
    maxWidth: WIDTH_MAX / 3,
  }

  const context = {
    organizations
  }

  return (
    <Layout style={layoutStyle}>
      <Layout.Content style={layoutContentStyle}>
        <Outlet context={context} />
      </Layout.Content>
    </Layout>
  )
}

export default ConsoleManagerLayout
